export default "__VITE_ASSET__eZm6BnAM__"